const Joi = require("joi");

const CommitteeHomePageIntegrationSchema = (data) => {
  const schema = Joi.object({
    /*******************  Sec-1 *********************/
    // committeeSectionOneTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // committeeSectionOneSubTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Sub Title.",
    //     "string.empty": "Please enter Sub Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Sub Title.",
    //   }),

    committeeSectionOneDescription: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        const strippedContent = value.trim();

        if (!strippedContent || strippedContent.length === 0) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),
    /*******************  Sec-2 *********************/
    // committeeSectionTwoTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    committeeSectionTwoDescription: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        const strippedContent = value.trim();

        if (!strippedContent || strippedContent.length === 0) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),
    /*******************  Sec-3 *********************/
    // committeeSectionThreeTitle: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid Title.",
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    committeeSectionThreeDescription: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        const strippedContent = value.trim();

        if (!strippedContent || strippedContent.length === 0) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),
    /*******************  Sec-4 *********************/
    // committeeSectionFiveCardOneTitle: Joi.string()
    //   .trim()
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // committeeSectionFiveCardOneDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    // committeeSectionFiveCardTwoTitle: Joi.string()
    //   .trim()
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // committeeSectionFiveCardTwoDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    // committeeSectionFiveCardThreeTitle: Joi.string()
    //   .trim()
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // committeeSectionFiveCardThreeDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    // committeeSectionFiveCardFourTitle: Joi.string()
    //   .trim()
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Title.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter Title.",
    //   }),

    // committeeSectionFiveCardFourDescription: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
    /*******************  Sec-5 *********************/
    committeeSectionSixBannerTitle: Joi.string()
      .trim()
      // .pattern(new RegExp('^[a-zA-Z0-9,.?" ]*$'))
      .pattern(new RegExp("^[a-zA-Z0-9 _@'-]*$"))
      .max(50)
      .messages({
        "string.pattern.base": "Please enter Valid Title.",
        "string.empty": "Please enter Title.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Title.",
      }),

    committeeSectionSixButtonLabel: Joi.string()
      .trim()
      .pattern(new RegExp('^[a-zA-Z0-9,-.?" ]*$'))
      .max(50)
      .required()
      .messages({
        "string.pattern.base": "Please enter Valid Label.",
        "string.empty": "Please enter Label.",
        "string.max": "Max length is 50.",
        "any.required": "Please enter Label.",
      }),

    // committeeSectionSixButtonUrl: Joi.string()
    //   .trim()
    //   .pattern(new RegExp('^[a-zA-Z0-9,.?/" ]*$'))
    //   .max(50)
    //   .required()
    //   .messages({
    //     "string.pattern.base": "Please enter Valid URL.",
    //     "string.empty": "Please enter URL.",
    //     "string.max": "Max length is 50.",
    //     "any.required": "Please enter URL.",
    //   }),

    committeeSectionSixButtonUrl: Joi.string()
      .uri()
      .max(2000) // adjust if needed
      .required()
      .messages({
        "string.uri": "Please enter a valid URL.",
        "string.empty": "Please enter URL.",
        "string.max": "Max length is 2000.",
        "any.required": "Please enter URL.",
      }),

    committeeSectionSixButtonTarget: Joi.string()
      .trim()
      .valid("_self", "_blank")
      .required()
      .messages({
        "any.only": "Invalid Target format.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = CommitteeHomePageIntegrationSchema;
